import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import HomeSettingsForm from '../../../components/SiteAdmin/HomeSettingsForm';
import Loader from '../../../components/Common/Loader/Loader';
import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';

const HomeSettings = ({ id }) => {

    const { loading, data } = useQueryResponse({
        query: getAllHomePageSettings,
        variables: { id },
        fetchPolicy: 'network-only',
    });

    const homepageCollection = useMemo(() => {
        const settings = data?.getAllHomePageSettings?.homePageData || [];

        return settings.reduce((acc, item) => {
            if (item?.dynamicHomePageSettings?.length > 0) {
                acc[item.name] = item.dynamicHomePageSettings.map(data => ({
                    value: data?.value || null,
                    language: data?.language || 'en-US',
                    description: data?.description
                }));
            } else {
                acc[item.name] = item?.value;
            }
            return acc;
        }, {});
    }, [data]);

    return (
        <Loader type="page" show={loading}>
            {!loading && <HomeSettingsForm initialValues={homepageCollection} />}
        </Loader>
    );
};

HomeSettings.propTypes = {
    id: PropTypes.number.isRequired,
};

export default HomeSettings;
